module.exports = __webpack_public_path__ + "media/15_ASANBUDAPEST-Vibes11.b372b035.mp3";